import React from 'react'
import { ArrowRight, CheckCircleFill } from 'react-bootstrap-icons'

import {
  OrderHistoryContainer,
  HistoryItemWrapper,
  DetailWrapper,
  ButtonWrapper
} from './styles'

import { useApi, useLanguage, useUtils, useConfig } from '~components'
import { formatSeconds, Button, getOrderStatusPrefix as getStatus } from '~ui'

export const OrderHistory = (props) => {
  const {
    messages,
    order,
    handleOpenReview,
    onClose,
    enableReview
  } = props

  const [{ dictionary }, t] = useLanguage()
  const [{ parseDate }] = useUtils()
  const [{ configs }] = useConfig()
  const [ordering] = useApi()
  const excludedMessages = ['manual_driver_assignment_comment', 'driver_group_id', 'manual_driver_assignment_author_id']

  const getLogisticTagStatus = (status) => {
    switch (status) {
      case 0:
        return t('PENDING', 'Pending')
      case 1:
        return t('IN_PROGRESS', 'In Progress')
      case 2:
        return t('IN_QUEUE', 'In Queue')
      case 3:
        return t('EXPIRED', 'Logistic expired')
      case 4:
        return t('RESOLVED', 'Resolved')
      default:
        return status
    }
  }

  const handleReview = () => {
    onClose()
    setTimeout(() => {
      enableReview && handleOpenReview && handleOpenReview()
    }, 1)
  }

  return (
    <OrderHistoryContainer>
      {!messages?.loading && order && (
        <HistoryItemWrapper>
          <CheckCircleFill />
          <DetailWrapper>
            <h3>
              {t('ORDER_PLACED', 'Order placed')} {' '}
              {!props.hideViaText && (
                <>
                  {t('VIA', 'Via')}{' '}
                  {order.app_id ? t(order.app_id.toUpperCase(), order.app_id) : t('OTHER', 'Other')}
                </>
              )}
            </h3>
            <p>{parseDate(order.created_at, { outputFormat: `MMM DD, ${configs?.general_hour_format?.value}` })}</p>
          </DetailWrapper>
        </HistoryItemWrapper>
      )}
      {messages && messages?.messages.map((message, i) => (message.type === 1 && !excludedMessages.includes(message?.change?.attribute)) && (
        <HistoryItemWrapper
          key={i}
        >
          <CheckCircleFill />
          <DetailWrapper>
            {message.change?.attribute !== 'driver_id'
              ? <h3>
                {message.change?.attribute === 'logistic_status'
                  ? getLogisticTagStatus(parseInt(message.change.new, 10))
                  : message.change?.attribute === 'delivered_in'
                    ? <h3>
                      <strong>{t('TIME_ADDED_BY_DRIVER', 'Time added by driver')}</strong><br />
                      {formatSeconds(parseInt(message.change.new, 10))}
                    </h3>
                    : message.change?.attribute === 'prepared_in'
                      ? <h3>
                        <strong>{t('TIME_ADDED_BY_BUSINESS', 'Time added by business')}</strong><br />
                        {formatSeconds(parseInt(message.change.new, 10))}
                      </h3>
                      : t(getStatus(message.change.new, dictionary, ordering.appInternalName?.toUpperCase?.()), getStatus(message.change.new, dictionary, ordering.appInternalName?.toUpperCase?.()).replace(/_/g, ' '))}
              </h3>
              : <h3>
                {message.change.new
                  ? <>
                    <strong>{message.driver?.name} {' '} {message.driver?.lastname && message.driver.lastname} </strong>
                    {t('WAS_ASSIGNED_AS_DRIVER', 'Was assigned as driver')}
                  </>
                  : t('DRIVER_UNASSIGNED', 'Driver unassigned')}
              </h3>}
            <p>{parseDate(message.created_at, { outputFormat: `MMM DD, ${configs?.general_hour_format?.value}` })}</p>
          </DetailWrapper>
        </HistoryItemWrapper>
      ))}
      <ButtonWrapper>
        <Button
          onClick={handleReview}
          color='primary'
        >
          {enableReview ? t('REVIEW_ORDER', 'Review order') : t('CONTINUE', 'Continue')}
          <ArrowRight />
        </Button>
      </ButtonWrapper>
    </OrderHistoryContainer>
  )
}
